import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, Box, Card, CardContent, Grid, Typography, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AbilityContext, Can } from 'context/Can';

import Breadcrumb from 'components/ui/Breadcrumb';
import { useSelector } from 'react-redux';
import {
    selectUserInstituteAddress,
    selectUserInstituteImageUrl,
    selectUserInstituteName,
    selectUserYearBookContactName,
    selectUserYearBookContactEmail,
    selectUserYearBookContactPhone,
    selectUserYearBookName
} from '../store/slices/authSlice';

import { getStudentCoordinatorRequest } from 'services/student';

const useStyles = makeStyles((theme) => ({
    mainHeading: {
        margin: theme.spacing(1),
        [theme.breakpoints.down('md')]: {
            textAlign: 'center'
        }
    },
    breadcrumbs: {
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center'
        }
    }
}));

function ContactUsPage(props) {
    const [coordinator, setCoordinator] = useState('');
    const classes = useStyles();

    const ability = useContext(AbilityContext);

    const navigate = useNavigate();

    const instituteLogoUrl = useSelector(selectUserInstituteImageUrl);
    const instituteName = useSelector(selectUserInstituteName);
    const instituteAddress = useSelector(selectUserInstituteAddress);
    const yearBookName = useSelector(selectUserYearBookName);
    const contactEmail = useSelector(selectUserYearBookContactEmail);
    const contactPersonName = useSelector(selectUserYearBookContactName);
    const contactPhone = useSelector(selectUserYearBookContactPhone);
    useEffect(() => {
        getStudentCoordinatorRequest().then((response) => {
            setCoordinator(response);
        });
    }, []);

    return (
        <>
            <Breadcrumb title="Contact Us" />
            <Grid container justifyContent="center">
                <Grid item xs={12} lg={12} xl={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <Grid container>
                                        <Grid item md={4}>
                                            <Box
                                                sx={{
                                                    px: 2,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flexDirection: 'column',
                                                    gap: 1,
                                                    textAlign: 'center'
                                                }}
                                            >
                                                <Avatar
                                                    src={`${process.env.REACT_APP_AWS_BASE_PATH}/${instituteLogoUrl}`}
                                                    alt={instituteName}
                                                />
                                                <Typography variant="h2">{instituteName}</Typography>
                                                <Typography variant="body1">{instituteAddress}</Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item md={8}>
                                            <Grid container>
                                                <Grid item xs={6}>
                                                    <Box p={2}>
                                                        <Typography variant="h4">Yearbook</Typography>
                                                        <Typography variant="body1">{yearBookName}</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Box p={2}>
                                                        <Typography variant="h4">Contact Person</Typography>
                                                        <Typography variant="body1">
                                                            {contactPersonName.trim().length === 0 ? '-' : contactPersonName}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            <Grid container>
                                                <Grid item xs={6}>
                                                    <Box p={2}>
                                                        <Typography variant="h4">Contact Email</Typography>
                                                        <Typography variant="body1">
                                                            {contactEmail.trim().length === 0 ? '-' : contactEmail}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Box p={2}>
                                                        <Typography variant="h4">Contact Phone</Typography>
                                                        <Typography variant="body1">
                                                            {contactPhone.trim().length === 0 ? '-' : contactPhone}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {/* {ability.can('all', 'coordinatorDetails') && ()} */}
            <Grid sx={{ mt: 3 }} container justifyContent="center">
                <Grid item xs={12} lg={12} xl={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <Typography
                                        sx={{ mb: 2 }}
                                        title={'Coordinator'}
                                        variant="h2"
                                        component="h2"
                                        textOverflow="ellipsis"
                                        noWrap
                                    >
                                        {'Coordinator'}
                                    </Typography>
                                    {/* {JSON.stringify(coordinator.students)} */}
                                    <Grid container>
                                        {coordinator?.students?.length > 0 &&
                                            coordinator.students?.map((student, index) => (
                                                <Grid sx={{ m: 2 }} key={index} item xs={3}>
                                                    <Paper
                                                        key={index}
                                                        className={classes.card}
                                                        variant="outlined"
                                                        elevation={0}
                                                        sx={{ p: 2 }}
                                                    >
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12}>
                                                                <Avatar
                                                                    alt={student.name}
                                                                    src={
                                                                        !student.image
                                                                            ? `${coordinator.imageBaseUrl}${student.image}`
                                                                            : 'no-image'
                                                                    }
                                                                    sx={{ height: 100, width: 100, mb: 1 }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Typography variant="h3" component="h3" textOverflow="ellipsis" noWrap>
                                                                    {student.name}
                                                                </Typography>
                                                                <Typography variant="caption">{student.contactNumber ?? '-'}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Grid>
                                            ))}
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default ContactUsPage;
